import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import globalTranslations from '../../../i18n/globalTranslations';

export const OrderLink = ({ id, link }) => {
  return (
    <Link key={link} className="OrderLink" to={link}>
      {id}
      {' ('}
      <FormattedMessage {...globalTranslations.orderListingWeb} />
      {')'}
    </Link>
  );
};

OrderLink.propTypes = {
  id: PropTypes.number.isRequired,
  link: PropTypes.string.isRequired,
};

export default OrderLink;
